module.exports = __webpack_public_path__ + "img/illustration.7a260c7b.svg";